import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../../components/Buttons";

export const SpendItem = () => {
    document.title = "Xərc maddəsi";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Maliyyə", value: "/finance" },
        { name: "Ödənişlər", value: "/finance/payments" },
        { name: "Xərc maddəsi", value: "/finance/payments/spenditem", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Xərc maddəsi</h2>
                    <p>
                        Həmçinin, şirkətin etdiyi bütün <b>xərclər</b> ödənişlər səhifəsindən həyata keçirilir. Qeyd: Uyğun olan xərc maddəsi seçilməlidir.
                        Nümunədə Maliyyə ⮞ Ödənişlər ⮞ Xərc maddəsinin formalaşdırılması göstərilib. <Button>Məxaric</Button> düyməsini sıxıb
                        <Button>Nağd</Button> və ya <Button>Nağdsız</Button> seçimin edib, açılan pəncərədə lazım olan xanaları doldurmaq lazımdır. Daha sonra
                        <Button>+</Button> düyməsi ilə yeni xərc maddəsi əlavə edib <SaveButton /> düyməsini sıxmaq lazımdır.
                    </p>
                    <img src="/images/finance/payments/spenditem.gif" alt="Xərc maddəsi" />
                </article>
            </div>
        </div>
    );
};
